'use es6';

import enviro from 'enviro';
export var ENV_NAME = 'MarketplaceUI';
export var debug = function debug() {
  var envName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ENV_NAME;
  return enviro.debug(envName);
};
export var deployed = function deployed() {
  return enviro.deployed(ENV_NAME);
};
export var getShort = function getShort() {
  return enviro.getShort(ENV_NAME);
};
export var isProd = function isProd() {
  return enviro.isProd(ENV_NAME);
};
export var isQa = function isQa() {
  return enviro.isQa(ENV_NAME);
};
export var isLocal = function isLocal() {
  return enviro.getShort(ENV_NAME) === 'local';
};